import React, { useContext } from "react";
import { FirstHeader } from "../../components/sharedComponents/FirstHeader";
import { CallAPI } from "../../config/api/ApiConfig";
import { LocaleContext } from "../../config/localization/LanguageProvider";

export const UserPrivacyPolicy = () => {
  const { locale } = useContext(LocaleContext);

  const { data: privacyPolicy } = CallAPI({
    name: "privacyPolicyUser",
    url: "/client/v1/page/privacy_policy",
    refetchOnWindowFocus: false,
    enabled: true,
    select: (res) => res?.data?.data,
  });

  return (
    <div className="terms p-0">
      <div className="container">
        <>
          <FirstHeader
            className="terms__header"
            text={
              locale === "ar" ? privacyPolicy?.name_ar : privacyPolicy?.name_en
            }
          />
        </>

        <div
          className="terms__content"
          dangerouslySetInnerHTML={{
            __html:
              locale === "ar" ? privacyPolicy?.body_ar : privacyPolicy?.body_en,
          }}
        />
      </div>
    </div>
  );
};
